import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { useIntl } from 'react-intl';
import { locales } from '@whitelabel/helpers/site';
import { updateLocale as updateLocaleAction } from '@whitelabel/actions';
import { Modal } from '@whitelabel/component-library';
import { hiddenLocaleCodes } from '@whitelabel/helpers/constants';
import { ILocales } from '@whitelabel/helpers/types';
import { StyledHeading, StyledLocaleListItem, StyledLocaleLink } from './styled';
import messages from './messages';

interface ILocaleModalProps {
  isOpen: boolean;
  toggle: () => void;
  updateLocale: (...args: any[]) => any;
}

const LocaleModal = ({ isOpen, toggle, updateLocale }: ILocaleModalProps) => {
  const intl = useIntl();
  const handleLocaleChange = (code: any) => () => updateLocale(code);
  const bodyContent = (
    <Row>
      {Object.values<ILocales>(locales)
        .filter((locale) => !hiddenLocaleCodes.includes(locale.code))
        .map(({ code, nameLocal }) => (
          <Col xs={6} sm={4} key={code}>
            <StyledLocaleListItem>
              <StyledLocaleLink
                $active={code === intl.locale}
                data-test-id="LocaleModal-item"
                data-analytics={`locale${nameLocal}`}
                onClick={handleLocaleChange(code)}
              >
                {nameLocal}
              </StyledLocaleLink>
            </StyledLocaleListItem>
          </Col>
        ))}
    </Row>
  );

  return (
    <Modal
      isOpen={isOpen}
      header={<StyledHeading>{intl.formatMessage(messages.header)}</StyledHeading>}
      body={bodyContent}
      toggle={toggle}
      backdrop
    />
  );
};

const mapDispatchToProps = {
  updateLocale: updateLocaleAction,
};

export default connect(null, mapDispatchToProps)(LocaleModal);
